<template>
  <div class="pt-3">
    <home-header></home-header>
    <div class="">
      <div class="regionPanel">
        <el-select v-model="selectedProvince" @change="changeProvince">
          <el-option
              v-for="(province, index) in provinces"
              :key="index"
              :label="province"
              :value="province">
          </el-option>
        </el-select>
        <el-checkbox class="pl-3" v-model="draggable">自定义距离</el-checkbox>
      </div>
      <div id="mapContainer"></div>
      <el-drawer :withHeader="false" :visible.sync="dlg_pkg_detail" :modal="true" size="630px">
        <div class="">
          <div class="col">
            <div class="bg-white p-3">
              <div v-if="form.idx=='staff'" class="content-box">
                <div class="title">找附近的老板
                </div>
                <div class="content">
                  <table style="width:600px;">
                    <tr>
                      <td style="width:60px;"><label class="">位置</label>
                      </td>
                      <td style="width:200px;"><span style="color:orangered;">{{ this.form.query }}</span>（经纬度）
                      </td>
                      <td style="width:60px;"><label class="">距离</label>
                      </td>
                      <td style="width:250px;">
                        <el-input-number v-model="form.distance" @change="search_action" :min="1" class="width_150"
                                         label="千米"></el-input-number>
                        （千米）
                      </td>
                    </tr>
                    <tr style="height:55px;">
                      <td><label class="">年龄</label>
                      </td>
                      <td>
                        <el-date-picker v-model="form.date_range" type="monthrange" @change="search_action"
                                        class="item_w_200"
                                        unlink-panels range-separator="——" start-placeholder="开始"
                                        end-placeholder="结束"
                                        :picker-options="birthOptions">
                        </el-date-picker>
                      </td>
                      <td><label class="">性别</label>
                      </td>
                      <td>
                        <el-radio v-model="form.gender" label="male" @change="search_action">男性</el-radio>
                        <el-radio v-model="form.gender" label="female" @change="search_action">女性</el-radio>
                        <el-radio v-model="form.gender" label="" @change="search_action">不限</el-radio>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <div v-else class="content-box">
                <div class="title">找附近的公司
                </div>
                <div class="content">
                  <table style="width:600px;">
                    <tr>
                      <td style="width:60px;"><label class="">位置</label>
                      </td>
                      <td style="width:200px;"><span style="color:orangered;">{{ this.form.query }}</span>（经纬度）
                      </td>
                      <td style="width:60px;"><label class="">距离</label>
                      </td>
                      <td style="width:250px;">
                        <el-input-number v-model="form.distance" @change="search_action" :min="1" class="width_150"
                                         label="千米"></el-input-number>
                        （千米）
                      </td>
                    </tr>
                    <tr style="height:55px;">
                      <td><label class="">行业</label>
                      </td>
                      <td>
                        <el-cascader class=""
                                     v-model="form.indusList"
                                     :options="indusList"
                                     :show-all-levels="false"
                                     :props="{ expandTrigger: 'hover',multiple: true, checkStrictly: true, value:'value',label:'label'}"
                                     @change="search_action"></el-cascader>
                      </td>
                      <td><label class="">规模</label>
                      </td>
                      <td>
                        <el-select class=""
                                   v-model="form.scaleList" clearable multiple placeholder="请选择"
                                   @change="search_action">
                          <el-option v-for="item in scaleList" :key="item.value" :label="item.label"
                                     :value="item.value"></el-option>
                        </el-select>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <div class="content pt-1">
                <label>搜索类型：</label>
                <el-radio-group v-model="form.idx" @change="radio_change">
                  <el-radio label="staff">找老板</el-radio>
                  <el-radio label="ent">找公司</el-radio>
                </el-radio-group>
              </div>
            </div>

          </div>
        </div>
        <div class="p-3">
          <el-button size="small" type="danger" class="float-right pb-1" @click="btn_export_data">导出数据
          </el-button>
          <el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange" class="pb-1"
                         :page-size="this.page.size" :total="this.page.total" :current-page="this.page.index+1">
          </el-pagination>
          <div v-if="form.idx=='staff'">
            <el-table :data="dataList" stripe v-loading="listLoading">
              <el-table-column property="name" label="姓名" width="90"></el-table-column>
              <el-table-column props="md5" label="OneID" width="150">
                <template slot-scope="scope">
                  <label @click="getPhoneNumber(scope.row.id,scope.row.md5)">{{
                      scope.row.md5 != null && scope.row.md5.length > 15 ? scope.row.md5.substring(0, 11) + "..." : scope.row.md5
                    }}</label>
                </template>
              </el-table-column>
              <el-table-column property="companyName" label="公司名" width=""></el-table-column>
              <el-table-column prop="scale" label="规模" width="65">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.scale=='超大型'" type="danger" effect="dark" size="small">
                    大型
                  </el-tag>
                  <el-tag v-if="scope.row.scale=='大型'" type="warning" effect="dark" size="small">
                    {{ scope.row.scale }}
                  </el-tag>
                  <el-tag v-if="scope.row.scale=='中型'" type="primary" effect="dark" size="small">
                    {{ scope.row.scale }}
                  </el-tag>
                  <el-tag v-if="scope.row.scale=='小型'" type="success" effect="dark" size="small">
                    {{ scope.row.scale }}
                  </el-tag>
                  <el-tag v-if="scope.row.scale=='微型'" type="info" effect="dark" size="small">
                    {{ scope.row.scale }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column property="typeJoin" label="职位" width="110"></el-table-column>
              <el-table-column property="share" label="股份" width="70"></el-table-column>
            </el-table>
          </div>
          <div v-else>
            <el-table :data="dataList" stripe v-loading="listLoading">
              <el-table-column property="company_name" label="公司名" width=""></el-table-column>
              <el-table-column property="legal_person" label="法人" width="100"></el-table-column>
              <el-table-column property="reg_date" label="成立时间" width="110"></el-table-column>
              <el-table-column property="reg_capital" label="注册资金" width="150"></el-table-column>
              <el-table-column property="scale" label="规模" width="85"></el-table-column>
            </el-table>
          </div>
        </div>
      </el-drawer>
      <export-data :dlg_export_model="dlg_export_model" :form="form"
                   @exportClose="dlg_export_model=false"></export-data>
    </div>
    <home-footer></home-footer>
  </div>
</template>
<script>
import api from "../../api/rest";
import util from "../../api/util";
import {eventBus} from '../../api/event-bus.js';

import EntList from "../../components/ExportData";
import ExportData from "../../components/ExportData.vue";
import HomeHeader from "../../components/HomeHeader.vue";
import HomeFooter from "../../components/HomeFooter.vue";

export default {
  name: 'App',
  components: {HomeFooter, HomeHeader, ExportData},
  data() {
    return {
      map: null,
      marker: null,
      dlg_pkg_detail: false,
      dlg_export_model: false,
      dlg_login_model: false,
      draggable: false,
      form: {
        distance: 10,
        query: "",
        query_field: "geo_distance",
        idx: 'staff',
        order: "cnt_v",
        total: 0
      },
      dataList: [],
      page: {
        total: 0,
        index: 0,
        size: 15,
      },
      listLoading: false,
      init_point: [39.960375, 116.397328],
      birthOptions: util.setting.getPickeAgeOpt(),
      scaleList: util.setting.getEntScaleList(),
      indusList: util.setting.getIndustry(),
      selectedProvince: '北京市',
      provinces: [
        '北京市', '天津市', '上海市', '重庆市', '河北省', '山西省', '辽宁省', '吉林省',
        '黑龙江省', '江苏省', '浙江省', '安徽省', '福建省', '江西省', '山东省',
        '河南省', '湖北省', '湖南省', '广东省', '海南省', '四川省', '贵州省',
        '云南省', '陕西省', '甘肃省', '青海省', '台湾省', '内蒙古自治区',
        '广西壮族自治区', '西藏自治区', '宁夏回族自治区', '新疆维吾尔自治区'
      ],
    };
  },
  methods: {
    radio_change() {
      let newForm = {}
      newForm.distance = this.form.distance
      newForm.order = this.form.order
      newForm.query_field = this.form.query_field
      newForm.idx = this.form.idx
      newForm.query = this.form.query
      this.form = newForm
      this.dataList = []
      this.search_action()
    },
    selsChange(val) {

    },
    changeProvince() {
      console.log(this.selectedProvince)
      // api.storage.set('sltProv', this.selectedProvince)
      // window.location.reload()


      // //地址和经纬度之间进行转换服务
      // geocoder = new qq.maps.Geocoder();
      // //设置服务请求成功的回调函数
      // geocoder.setComplete(function(result) {
      //   map.setCenter(result.detail.location);
      //   var marker = new qq.maps.Marker({
      //     map: map,
      //     position: result.detail.location
      //   });
      //   //点击Marker会弹出反查结果
      //   qq.maps.event.addListener(marker, 'click', function() {
      //     alert("坐标地址为： " + result.detail.location);
      //   });
      // });
      // //若服务请求失败，则运行以下函数
      // geocoder.setError(function() {
      //   alert("出错了，请输入正确的地址！！！");
      // });
      //
      // geocoder.getLocation(address);
      // this.geocoder.getLocation("中国,北京,海淀区,海淀大街38号")

      let center = new qq.maps.LatLng(39.960375, 116.397328)
      if (this.selectedProvince == "上海市") {
        center = new qq.maps.LatLng(31.0976, 121.4951)
      } else if (this.selectedProvince == "北京市") {
        center = new qq.maps.LatLng(39.960375, 116.397328)
      } else if (this.selectedProvince == "重庆市") {
        center = new qq.maps.LatLng(29.5752, 106.7432)
      } else if (this.selectedProvince == "天津市") {
        center = new qq.maps.LatLng(39.1024, 117.1461)
      } else if (this.selectedProvince == "山东省") {
        center = new qq.maps.LatLng(36.5802, 117.1582)
      } else if (this.selectedProvince == "山西省") {
        center = new qq.maps.LatLng(37.7164, 112.5522)
      } else if (this.selectedProvince == "河北省") {
        center = new qq.maps.LatLng(37.9182, 114.5819)
      } else if (this.selectedProvince == "台湾省") {
        center = new qq.maps.LatLng(24.9861, 121.5115)
      } else if (this.selectedProvince == "内蒙古自治区") {
        center = new qq.maps.LatLng(40.6640, 111.8353)
      } else if (this.selectedProvince == "黑龙江省") {
        center = new qq.maps.LatLng(45.4909, 126.4966)
      } else if (this.selectedProvince == "吉林省") {
        center = new qq.maps.LatLng(43.7770, 125.3238)
      } else if (this.selectedProvince == "辽宁省") {
        center = new qq.maps.LatLng(41.6565, 123.6182)
      } else if (this.selectedProvince == "江苏省") {
        center = new qq.maps.LatLng(32.0894, 118.6577)
      } else if (this.selectedProvince == "浙江省") {
        center = new qq.maps.LatLng(30.1691, 120.2124)
      } else if (this.selectedProvince == "福建省") {
        center = new qq.maps.LatLng(26.1456, 119.4873)
      } else if (this.selectedProvince == "广东省") {
        center = new qq.maps.LatLng(23.2918, 113.2306)
      } else if (this.selectedProvince == "海南省") {
        center = new qq.maps.LatLng(19.8752, 110.2203)
      } else if (this.selectedProvince == "湖北省") {
        center = new qq.maps.LatLng(30.4913, 114.3347)
      } else if (this.selectedProvince == "湖南省") {
        center = new qq.maps.LatLng(27.9701, 112.7637)
      } else if (this.selectedProvince == "四川省") {
        center = new qq.maps.LatLng(30.4060, 104.0735)
      } else if (this.selectedProvince == "云南省") {
        center = new qq.maps.LatLng(24.6570, 102.8815)
      } else if (this.selectedProvince == "贵州省") {
        center = new qq.maps.LatLng(26.4755, 106.6553)
      } else if (this.selectedProvince == "安徽省") {
        center = new qq.maps.LatLng(31.7212, 117.2873)
      } else if (this.selectedProvince == "江西省") {
        center = new qq.maps.LatLng(28.6038, 115.8591)
      } else if (this.selectedProvince == "河南省") {
        center = new qq.maps.LatLng(34.6535, 113.6398)
      } else if (this.selectedProvince == "陕西省") {
        center = new qq.maps.LatLng(34.2232, 108.9432)
      } else if (this.selectedProvince == "甘肃省") {
        center = new qq.maps.LatLng(35.8891, 103.8593)
      } else if (this.selectedProvince == "青海省") {
        center = new qq.maps.LatLng(36.4964, 101.7911)
      } else if (this.selectedProvince == "宁夏回族自治区") {
        center = new qq.maps.LatLng(38.4536, 106.2433)
      } else if (this.selectedProvince == "新疆维吾尔自治区") {
        center = new qq.maps.LatLng(43.6520, 87.6270)
      } else if (this.selectedProvince == "西藏自治区") {
        center = new qq.maps.LatLng(29.5687, 91.1810)
      } else if (this.selectedProvince == "广西壮族自治区") {
        center = new qq.maps.LatLng(22.6343, 108.3746)
      }
      this.map.setCenter(center)
    },
    loadMapScript(lat, lng) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = `https://map.qq.com/api/js?v=2.exp&key=FMUBZ-SLG6J-ISHF7-DUREO-IDZGT-NRFUN`; // 请替换YOUR_KEY_HERE为你的API密钥
      script.onload = () => {
        this.initMap()
      }
      document.body.appendChild(script)
    },
    getPhoneNumber(hum_id, md5) {
      if (api.storage.get('user') == null) {
        // 发送需要登录消息
        eventBus.$emit('event_loginRequire', 'true');
        return
      }
      if (md5 == null)
        return
      let para = {
        "id": hum_id,
        "md5": md5
      }
      let api_url = "/search/humPhoneDec"
      api.remote.doPost(para, api_url).then((res) => {
        if (res.status == 'error') {
          this.$message({
            title: '',
            message: res.message,
            type: res.status
          })
        } else {
          this.$message({
            title: '',
            message: res,
            type: 'success'
          })
        }
      }).catch((res) => {
        api.handError.action(this, res);
      });
    },
    exportCloseHandler() {
      this.dlg_export_model = false
    },
    search_action() {
      this.listLoading = true;
      let api_url = ''
      if (this.form.idx == 'staff') {
        api_url = "/slice/humQuery"
      } else {
        api_url = "/slice/entQuery"
      }

      this.dataList = []
      let para = {
        ...this.form,
        ...this.page
      }
      api.remote.doPost(para, api_url).then((res) => {
        if (res.status == "error") {
          this.$message({
            title: res.title,
            message: res.message,
            type: res.status
          })
        }
        this.dataList = res.content;
        this.page.total = res.totalElements
        this.listLoading = false;
      }).catch((res) => {
        this.listLoading = false;
        api.handError.action(this, res);
      });
    },
    initMap(lat, lng) {
      if (lat == null && lng == null) {
        lat = 39.960375
        lng = 116.397328
      }
      const center = new qq.maps.LatLng(lat, lng);
      this.map = new qq.maps.Map(document.getElementById('mapContainer'), {
        center: center, // 地图中心点
        zoom: 11 // 地图显示的缩放级别
      });


      let drawing = false;
      let startPoint = null;
      let circle = null;
      // 鼠标按下事件
      qq.maps.event.addListener(this.map, 'mousedown', (e) => {
        if (this.marker) {
          this.marker.setMap(null); // 先移除之前的标记点
        }
        if (this.circle) {
          this.circle.setMap(null)
        }
        drawing = !drawing;
        if (this.draggable) {
          if (drawing) {
            startPoint = e.latLng;
            if (circle) {
              circle.setMap(null);
            }
          } else {
            this.marker = new qq.maps.Marker({
              position: startPoint,
              map: this.map
            });
            this.dlg_pkg_detail = true;
            this.form.query = e.latLng.lng.toFixed(4) + "," + e.latLng.lat.toFixed(4)
            this.search_action()
          }
        } else {
          this.dlg_pkg_detail = true;
          this.form.query = e.latLng.lng.toFixed(4) + "," + e.latLng.lat.toFixed(4)
          this.search_action()
          this.marker = new qq.maps.Marker({
            position: e.latLng,
            map: this.map
          });
          this.circle = new qq.maps.Circle({
            center: new qq.maps.LatLng(e.latLng.lat, e.latLng.lng), // 圆心坐标，同地图中心点
            radius: this.form.distance * 1000, // 圆半径，单位为米
            strokeColor: "blue", // 圆边框颜色
            strokeWeight: 1, // 圆边框线宽度
            fillOpacity: 0.3 // 圆填充透明度
          });
          this.circle.setMap(this.map);
        }
      });
      // 鼠标移动事件
      qq.maps.event.addListener(this.map, 'mousemove', (event) => {
        if (this.draggable && drawing) {
          const endPoint = event.latLng;
          const radius = qq.maps.geometry.spherical.computeDistanceBetween(startPoint, endPoint);
          this.form.distance = Math.round(radius) / 1000
          if (circle) {
            circle.setMap(null);
          }
          circle = new qq.maps.Circle({
            center: startPoint,
            radius: radius,
            strokeColor: "blue", // 圆边框颜色
            strokeWeight: 1, // 圆边框线宽度
            fillOpacity: 0.5, // 圆填充透明度
            map: this.map
          });
        }
      });
      // 鼠标抬起事件
      qq.maps.event.addListener(this.map, 'mouseup', () => {
        drawing = false;
      });


      // 处理地图点击事件
      // qq.maps.event.addListener(this.map, 'click', (e) => {
      //   if (this.marker) {
      //     this.marker.setMap(null); // 先移除之前的标记点
      //   }
      //   if (this.circle) {
      //     this.circle.setMap(null)
      //   }
      //   this.dlg_pkg_detail = true;
      //   this.form.query = e.latLng.lng.toFixed(4) + "," + e.latLng.lat.toFixed(4)
      //   this.search_action()
      //   this.marker = new qq.maps.Marker({
      //     position: e.latLng,
      //     map: this.map
      //   });
      //   this.circle = new qq.maps.Circle({
      //     center: new qq.maps.LatLng(e.latLng.lat, e.latLng.lng), // 圆心坐标，同地图中心点
      //     radius: this.form.distance * 1000, // 圆半径，单位为米
      //     strokeColor: "blue", // 圆边框颜色
      //     strokeWeight: 1, // 圆边框线宽度
      //     fillOpacity: 0.3 // 圆填充透明度
      //   });
      //   this.circle.setMap(this.map);
      // });
    },
    handleCurrentChange(val) {
      this.page.index = val - 1;
      this.search_action()
    },
    btn_export_data() {
      if (api.storage.get('user') == null) {
        // 发送需要登录消息
        eventBus.$emit('event_loginRequire', 'true');
      } else {
        this.form.total = this.page.total
        this.form.totalAmount = this.page.total / 100
        this.dlg_export_model = true;
      }
    },
    set_map_height() {
      const myDiv = document.getElementById('mapContainer');

      function setDivHeight() {
        const windowHeight = window.innerHeight;
        myDiv.style.height = windowHeight - 85 + "px"
      }

      window.addEventListener('resize', setDivHeight);
      setDivHeight();
    },
    init_page() {

    }
  },
  filters: {
    formatMoney(num) {
      num = num / 10000
      return num.toString().replace(/\d+/, function (n) {
        return n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      }) + "万";
    },
    formatDateTime(time) {
      var date = new Date(time)
      return date.format("yyyy-MM-dd")
    },
    formatPhone(phone) {
      if (phone == null || phone.length < 1) {
        return ''
      } else {
        return phone[0]
      }
    }
  },
  mounted() {
    this.loadMapScript();
    this.set_map_height();
    this.init_page();
  },
};
</script>

<style scoped>
#mapContainer {
  width: 100%;
}

.regionPanel {
  position: absolute;
  top: 90px;
  left: 100px;
  z-index: 999;
  height: 35px;
  padding: 30px;
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.el-pagination__total {
  color: orangered !important;
}

</style>



// WEBPACK FOOTER //
// Map.vue?2d140152